import LoadingNotification from "lib/ui/list-loading-notification";
import useInfiniteScroll from "lib/use-infinite-scroll";
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";

import DrEventListItem from "./dr-event-list-item";
import drEventsData from "./dr-events-data";

const DrEventsAdmin = () => {
  const {
    items,
    setScroller: setInfiniteScroller,
    handleScroll: handleInfiniteScroll,
    isLoading
  } = useInfiniteScroll(drEventsData);

  const setScroller = element => {
    setInfiniteScroller(element);
  };

  const handleScroll = () => {
    handleInfiniteScroll();
  };

  const [selectedDrEvent, setSelectedDrEvent] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [selectedResoureActivation, setSelectedResourceActivation] = useState(
    null
  );

  return (
    <div>
      <div className="max-h-full flex flex-row p-2">
        <div
          className="max-h-full bg-white overflow-y-scroll overflow-x-visible relative"
          ref={element => setScroller(element)}
          onScroll={handleScroll}
        >
          <div>
            {items.map(item => (
              <Fragment key={item.id}>
                <div
                  className="event flex-none  p-6  hover:bg-blue-200 hover:border-b-4 cursor-pointer"
                  onClick={() => setSelectedDrEvent(item)}
                >
                  <DrEventListItem item={item} />
                </div>
              </Fragment>
            ))}
          </div>
          {isLoading && <LoadingNotification />}
        </div>

        <div className="max-h-full bg-white ml-10 overflow-y-scroll">
          {selectedDrEvent && (
            <DrEventResourceActivations
              resourceActivations={selectedDrEvent.resourceActivations}
              setSelectedResourceActivation={setSelectedResourceActivation}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const DrEventResourceActivations = ({
  resourceActivations,
  setSelectedResourceActivation
}) => {
  const clicked = item => {
    console.log("clicked");
    setSelectedResourceActivation(item);
  };
  return (
    <table className="p-6">
      <thead>
        <tr>
          <th>Resource Name</th>
          <th>Schedule </th>
        </tr>
      </thead>
      <tbody>
        {resourceActivations.map(item => (
          <Fragment key={item.resourceId}>
            <tr className="cursor-pointer" onClick={() => clicked(item)}>
              <td>{item.description}</td>
            </tr>
          </Fragment>
        ))}
      </tbody>
    </table>
  );
};

DrEventResourceActivations.propTypes = {
  resourceActivations: PropTypes.array,
  setSelectedResourceActivation: PropTypes.func
};

const ResourceContributors = ({ contributors }) => {
  return (
    <table className="p-6">
      <thead>
        <tr>
          <th>Resource Name</th>
          <th>Schedule </th>
        </tr>
      </thead>
      <tbody>
        {contributors.map(item => (
          <Fragment key={item.id}>
            <tr>
              <td>{item.name}</td>
            </tr>
          </Fragment>
        ))}
      </tbody>
    </table>
  );
};

ResourceContributors.propTypes = {
  contributors: PropTypes.array
};

export default DrEventsAdmin;
